// MDU roles. Mirrors the Uniticket role/auth-type pattern, but with MDU's two
// roles instead of Uniticket's three (the operatorId → contractorId scope swap):
//   STAFF    — Unifiber staff; sees every contractor; signs in via Entra-ID SSO.
//   PROVIDER — SSV/TSA provider; scoped to its own contractorId; password + TOTP.
export const ROLES = {
    STAFF: 'STAFF',
    PROVIDER: 'PROVIDER',
};
// Per-provider sub-role (G2-1b). Only meaningful for PROVIDER users (null for STAFF):
//   ADMIN — manages its subco's other accounts AND sees prices (canViewAmounts derived).
//   TECH  — a regular subco worker: no account management, never sees prices.
export const SUB_ROLES = {
    ADMIN: 'ADMIN',
    TECH: 'TECH',
};
export const AUTH_TYPES = {
    ENTRA_ID: 'ENTRA_ID',
    LOCAL: 'LOCAL',
    BOTH: 'BOTH',
};
//# sourceMappingURL=roles.js.map